<template>
  <div class="mentor-team">
    <div class="mentor-content">
      <div class="title"><img src="./images/title.png"></div>
      <div class="main">
        <div class="content flex-row">
          <div
          :id="`myElement${item.id}`"
          :class="[ item.id == 1 ? 'item flex-cl hoverItem' : 'item flex-cl']"
          v-for="item in mentorTeamList" :key="item.name"
          @mouseenter="handleMouseenter(item.id)"
          @mouseleave="handleMouseleave(item.id)">
            <div class="head-sculpture flex-row">
              <img :src="require(`./images/${item.headSculpture}`)">
              <div class="hober">
                <p>{{item.name}} </p>
                <p>{{item.enName}}</p>
                <p>{{item.position}}</p>
                <p>{{item.enPosition1}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <go-top></go-top>
  </div>
</template>

<script>
import goTop from "../../common/go-top.vue";
export default {
  name: "MentorTeam",
  components: {
    goTop,
  },
  data() {
    return {
      // swiperOptions: {
      //   effect: 'slide',
      //   height: 722,
      //   // 分页器
      //   pagination: {
      //     el: '.swiper-pagination',
      //     clickable: true,
      //     bulletClass: 'mentor-team-bullet',
      //     bulletActiveClass: 'mentor-team-active'
      //   },
      //   direction: 'horizontal',// 横滚，水平滚动
      //   // 左右按钮
      //   navigation: {
      //     nextEl: '.swiper-button-next', //前进按钮的css选择器或HTML元素。
      //     prevEl: '.swiper-button-prev', //后退按钮的css选择器或HTML元素。
      //   },
      //   loop: true,// 从第一个直接滑到最后一个
      //   // loopedSlides: 6, //在loop 模式下使用 slidesPerview:'auto' ，还需使用该参数设置所要用到的loop 个数(一般设置大于可视slide个数2个即可)。
      //   // freeMode: false,
      //   // observer:true,         //修改swiper自己或子元素时，自动初始化swiper
      //   // observeParents:true,   //修改swiper的父元素时，自动初始化swiper
      //   // parallax: true,
      //   // speed: 2000,
      // },
      mentorTeamList: [
        {
          id: 1,
          headSculpture: 'caodewang.png',
          name: '曹德旺',
          enName: 'Cao Dewang',
          position: '福耀玻璃集团创始人、董事长',
          enPosition1: 'Founder and Chairman, Fuyao Glass Group'
        },
        {
          id: 2,
          headSculpture: 'zhangweiying.png',
          name: '张维迎',
          enName: 'Zhang Weiying',
          position: '著名经济学家、北大国家发展研究院经济学教授',
          enPosition1: 'Renowned Economist Professor, National School of Development, Peking University',
        },
        {
          id: 3,
          headSculpture: 'zhouqiren.png',
          name: '周其仁',
          enName: 'Zhou Qiren',
          position: '著名经济学家、北大国家发展研究院经济学教授',
          enPosition1: 'Renowned Economist、Professor of Economics, National School of Development, Peking University',
        },
        {
          id: 4,
          headSculpture: 'lidongsheng.png',
          name: '李东生',
          enName: 'Li Dongsheng',
          position: 'TCL董事长',
          enPosition1: 'Chairman, TCL Corporation'
        },
        {
          id: 5,
          headSculpture: 'guoguangchang.png',
          name: '郭广昌',
          enName: 'Guo Guangchang',
          position: '复星集团创始人、董事局主席',
          enPosition1: 'Founder, Shanghai Fosun Pharmaceutical (Group)Co.,Ltd.Chairman, Fosun International Limited'
        },
        {
          id: 6,
          headSculpture: 'liujiren.png',
          name: '刘积仁',
          enName: 'Liu Jiren',
          position: '东软集团创始人、董事会主席',
          enPosition1: 'Founder and Chairman, Neusoft Corporation'
        },
        {
          id: 7,
          headSculpture: 'lvjianming.png',
          name: '吕建明',
          enName: 'Lv Jianming',
          position: '通策医疗集团董事长',
          enPosition1: 'Chairman, Uni-medical Healthcare Group'
        },
        {
          id: 8,
          headSculpture: 'jiangnanchun.png',
          name: '江南春',
          enName: 'Jiang Nanchun',
          position: '分众传媒集团创始人',
          enPosition1: 'Founder, Focus Media Group'
        },
        {
          id: 9,
          headSculpture: 'lixiaojia.png',
          name: '李小加',
          enName: 'Li Xiaojia',
          position: '滴灌通集团创始人、香港联交所原行政总裁',
          enPosition1: 'Founder and Chairman, Drip Irrigation Group'
        },
        {
          id: 10,
          headSculpture: 'antonyleung.png',
          name: '梁锦松',
          enName: 'Antony Leung',
          position: '南丰集团董事长、香港原财政司司长',
          enPosition1: 'Chairman, Nan Fung Group、Former Financial Secretary of the Hong Kong Government'
        },
        {
          id: 11,
          headSculpture: 'vincentlo.png',
          name: '罗康瑞',
          enName: 'Vincent Lo',
          position: '瑞安集团主席、香港原贸发局理事',
          enPosition1: 'Chairman, Shuioncon Struction、Director, Hong Kong Trade Development Council'
        },
        {
          id: 12,
          headSculpture: 'ronniechan.png',
          name: '陈启宗',
          enName: 'Ronnie Chen',
          position: '香港恒隆地产原董事长、亚洲协会执行理事',
          enPosition1: 'Honorary Chairman, HangLung Properties、Executive Director, Asia Society'
        },
        {
          id: 13,
          headSculpture: 'lipingzhang.png',
          name: '张利平',
          enName: 'Liping Zhang',
          position: '黑石集团大中华区主席',
          enPosition1: 'Chairman, Greater China of Blackstone'
        },
        {
          id: 14,
          headSculpture: 'xiadawei.png',
          name: '夏大慰',
          enName: 'Xia Dawei',
          position: '国家会计学院创始院长',
          enPosition1: 'Former Dean, Shanghai National Accounting Institute、Honorary Professor, The Chinese University of Hong Kong'
        },
        {
          id: 15,
          headSculpture: 'wangfanghua.png',
          name: '王方华',
          enName: 'Wang Fanghua',
          position: '上海交通大学校长特聘顾问',
          enPosition1: 'Former Dean, Antai College of Economics and Management, SJTU、Special Advisor to the President, Shanghai Jiao Tong University'
        },
        {
          id: 16,
          headSculpture: 'fenglun.png',
          name: '冯仑',
          enName: 'Feng Lun',
          position: '著名企业家、企业思想家',
          enPosition1: 'Chairman, Yu Feng Group、Founder, Jilin Wantong Group Co., Ltd'
        },
        {
          id: 17,
          headSculpture: 'yuminhong.png',
          name: '俞敏洪',
          enName: 'Yu Minhong',
          position: '新东方教育集团创始人',
          enPosition1: 'Founder, New Oriental Education Group'
        },
        {
          id: 18,
          headSculpture: 'zhouhongyi.png',
          name: '周鸿祎',
          enName: 'Zhou Hongyi',
          position: '360公司创始人',
          enPosition1: 'Founder, 360 Group'
        },
        {
          id: 19,
          headSculpture: 'lirucheng.png',
          name: '李如成',
          enName: 'Li Rucheng',
          position: '宁波雅戈尔控股有限公司董事长',
          enPosition1: 'Chairman, Ningbo Peacebird Fashion Co., Ltd.'
        },
        {
          id: 20,
          headSculpture: 'wangshi.png',
          name: '王石',
          enName: 'Wang Shi',
          position: '万科集团创始人、著名社会公益人士',
          enPosition1: 'Founder, China Vanke Co.,Ltd、Founder, Destone Group'
        },
        {
          id: 21,
          headSculpture: 'wangwenjing.png',
          name: '王文京',
          enName: 'Wang Wenjing',
          position: '用友网络科技董事长兼CEO',
          enPosition1: 'Chairman and CEO, UFIDA Network Technology'
        },
        {
          id: 22,
          headSculpture: 'fanghongbo.png',
          name: '方洪波',
          enName: 'Fang Hongbo',
          position: '美的集团董事长',
          enPosition1: 'Chairman, Midea Group'
        },
        {
          id: 23,
          headSculpture: 'dingzuohong.png',
          name: '丁佐宏',
          enName: 'Ding Zuohong',
          position: '月星集团董事局主席',
          enPosition1: 'Chairman, Yue Xing Group'
        },
        {
          id: 24,
          headSculpture: 'chendongsheng.png',
          name: '陈东升',
          enName: 'Chen Dongsheng',
          position: '泰康保险集团创始人董事长兼CEO',
          enPosition1: 'Founder, Chairman, and CEO, Taikang Insurance Group'
        },
        {
          id: 25,
          headSculpture: 'houchengjun.png',
          name: '侯呈军',
          enName: 'Hou Chengjun',
          position: '珀莱雅董事长',
          enPosition1: 'Chairman, Pechoin'
        },
        {
          id: 26,
          headSculpture: 'liushufeng.png',
          name: '刘曙峰',
          enName: 'Liu Shufeng',
          position: '恒生电子董事长',
          enPosition1: 'Chairman, Hengsheng Electronics'
        },
        {
          id: 27,
          headSculpture: 'dingshuibao.png',
          name: '丁水波',
          enName: 'Ding Shuibo',
          position: '特步集团董事局主席',
          enPosition1: 'Chairman, Anta Group'
        },
        {
          id: 28,
          headSculpture: 'liuyonghao.png',
          name: '刘永好',
          enName: 'Liu Yonghao',
          position: '新希望集团董事长',
          enPosition1: 'Chairman, New Hope Group'
        },
        {
          id: 29,
          headSculpture: 'ruanliping.png',
          name: '阮立平',
          enName: 'Ruan Liping',
          position: '公牛集团董事长',
          enPosition1: 'Chairman, Bull Group'
        },
        {
          id: 30,
          headSculpture: 'wangxiangrong.png',
          name: '王相荣',
          enName: 'Wang Xiangrong',
          position: '利欧股份董事长',
          enPosition1: 'Chairman, Leroy Holding'
        },
        {
          id: 31,
          headSculpture: 'dinglei.png',
          name: '丁磊',
          enName: 'Ding Lei',
          position: '网易集团创始人',
          enPosition1: 'Founder, NetEase Group'
        },
      ],
    }
  },
  methods: {
    handleMouseenter(id){
      const myElement = document.getElementById(`myElement${id}`);
      if (myElement) {
        myElement.classList.add('hoverItem');
      }
      this.mentorTeamList.map(item => {
        const otherElement = document.getElementById(`myElement${item.id}`);
        if(item.id !== id){
          otherElement.classList.remove('hoverItem');
        }
      })
    },
    handleMouseleave(id){
      const myElement = document.getElementById(`myElement${id}`);
      myElement.classList.remove('hoverItem');
    }
  }
}
</script>

<style scoped>
.mentor-team{
  width: 100%;
  background: url("./images/bg.png") no-repeat center center;
}
.mentor-content{
  margin: 0 auto;
  padding-top: 83px;
  padding-bottom: 69.5px;
  width: 1215px;
  min-width: 1215px;
}
.mentor-team .main{
  margin-top: 31.5px;
  align-items: center;
  position: relative;
}
.mentor-team .content{
  width: 1215px;
  flex-wrap: wrap!important;
}
.mentor-team .flex-row{
  display: flex;
  flex-flow: row;
}
.mentor-team .flex-cl{
  display: flex;
  flex-flow: column;
}
.mentor-team .item{
  width: 390px;
  height: 240px;
  margin: 7.5px;
  color: #333333;
  background: #FAFAFA;
  border: 1px solid #B5B5B5;
  box-sizing: border-box;
  overflow: hidden;
}
.mentor-team .hoverItem{
  color: #FFFFFF!important;
  background: #0550AC;
  border: none;
  box-shadow: 0px 5px 10px 1px rgba(0,0,0,0.1);
}
.mentor-team .head-sculpture{
  align-items: center;
  transition: all .5s ease 0s;
}
.mentor-team .head-sculpture:hover{
  transform: scale(1.06);
}
.mentor-team .head-sculpture p{
  text-align: center;
  font-family: Source Han Sans CN;
  font-size: 22px;
  margin-bottom: 8px;
}
.mentor-team .hober{
  flex: 1;
  padding: 0 15px;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: space-between;
}
.mentor-team .head-sculpture p:nth-child(1){
  font-weight: 700;
}
.mentor-team .head-sculpture p:nth-child(2){
  font-size: 16px;
  margin-bottom: 30px;
  font-family: Gotham;
}
.mentor-team .head-sculpture p:nth-child(3) {
  font-size: 14px;
  line-height: 24px;
  margin-bottom: 10px;
}
.mentor-team .head-sculpture p:nth-child(4) {
  font-size: 12px;
  line-height: 16px;
  font-family: Gotham;
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/mentorTeam/MentorTeam.vue